import { useState } from "react";
import { SourcesParams, SourcesRequest } from "@/services/backend/cpy/api/cpy";
import { CpyName } from "../types/entity-names";
import {
  CpySourcesTable,
  CpySourcesTableFilterOptions,
  CpySourcesTableFilters,
} from "./cpy-sources-table";

export function CpySources({
  destinationEntityName,
  destinationId,
  onCopySuccess,
  initialParams,
  sourceEntityNames,
  ...props
}: {
  destinationEntityName: CpyName;
  destinationId: string;
  onCopySuccess?: () => void;
  initialParams?: SourcesParams;
  /**
   * Restricts the listed sources to these kinds. Without it every kind
   * the destination can be copied from is listed. The search by reference
   * number respects it, like every other param (e.g. the process).
   */
  sourceEntityNames?: CpyName[];
} & CpySourcesTableFilterOptions) {
  const [request, setRequest] = useState<SourcesRequest>({
    destinationEntityName,
    sourceEntityNames,
    params: initialParams || {
      orderBy: [{ field: "updatedAt", dsc: true }],
    },
  });

  return (
    <div className="grid gap-2">
      <CpySourcesTableFilters
        request={request}
        onRequestChange={setRequest}
        {...props}
      />
      <CpySourcesTable
        request={request}
        destinationId={destinationId}
        onCopySuccess={onCopySuccess}
      />
    </div>
  );
}
